export default __webpack_public_path__ + "static/media/pokemon4.4709ee32.png";